export const ALL_PLATFORMS_PROD = {
  app: 'https://app.pokerpower.com',
  learn: 'https://learn.pokerpower.com',
  web: 'https://pokerpower.com'
} as const

export const ALL_PLATFORMS_DEV = {
  app: 'https://app.dev.pokerpower.com'
  // learn: 'https://learn.pokerpower.com',
  // web: ''
} as const

export const ALL_PLATFORMS = process.env.EXPO_PUBLIC_STAGE === 'prod' ? ALL_PLATFORMS_PROD : ALL_PLATFORMS_DEV

export type PlatformKey = keyof typeof ALL_PLATFORMS
